import type { JSX } from 'react';

import { Text } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

import type { OperationHistoryEventDiff } from '../OperationHistory.types';

import styles from './OperationHistoryDiff.module.css';

interface OperationHistoryDiffProps {
  diffs: OperationHistoryEventDiff | OperationHistoryEventDiff[];
}

const ARROW_ICON_SIZE = 14;

function DiffRow({ diff }: { diff: OperationHistoryEventDiff }): JSX.Element {
  return (
    <div className={styles.diffRow}>
      {diff.label && (
        <Text size="xs" c="dimmed" fw={500} className={styles.diffLabel}>
          {diff.label}
        </Text>
      )}
      <div className={styles.diffValues}>
        {diff.from != null && (
          <span className={styles.fromPill}>{diff.from}</span>
        )}
        {diff.from != null && diff.to != null && (
          <IconArrowRight size={ARROW_ICON_SIZE} className={styles.arrow} />
        )}
        {diff.to != null && <span className={styles.toPill}>{diff.to}</span>}
      </div>
    </div>
  );
}

export function OperationHistoryDiff({
  diffs,
}: OperationHistoryDiffProps): JSX.Element | null {
  if (!diffs) return null;

  const diffArray = Array.isArray(diffs) ? diffs : [diffs];

  if (diffArray.length === 0) return null;

  return (
    <div className={styles.container}>
      {diffArray.map((diff, index) => (
        <DiffRow key={diff.label ?? index} diff={diff} />
      ))}
    </div>
  );
}
